import { FC, useState, useEffect, useContext } from "react";
import { Grid, Container, Box, Divider } from "@material-ui/core";
import AdminHeader from "../SubComponents/AdminHeader";
import useStyles from "../Styles/LearnStyles";
import WalletStepper from "../ConnectWallet/WalletStepper";
import Footer from "../SubComponents/Footer";
import WhitelistFail from "../Congrat/WhitelistFail";
import {
  animateScroll as scroll,
} from "react-scroll";
import LearnContext, { useLearnContext } from "../../store/Learn2/LearnContext";

const LearnFail: FC = (stepperIndex) => {

  const { getAuthUserPoolQuiz, resetLearnState } = useLearnContext();
  
  useEffect(() => {
    scroll.scrollToTop();
    cleanUp();
  }, []);

  const cleanUp = async () => {
    await getAuthUserPoolQuiz();
    resetLearnState();
  }

  const classes = useStyles();
  const [learnCompleteStep, setlearnCompleteStep] = useState(true);

  return (
    <>
      <AdminHeader isProject={true} />
      <WalletStepper nochange={true} stepperIndex={stepperIndex} disableModals={false} learnCompleteStep={learnCompleteStep} />
      <Box mt={3}>
        <Divider />
      </Box>
      <Box className={classes.learnpages} component="section">
        <Container fixed>
          <Grid container justifyContent="center">
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <WhitelistFail />
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default LearnFail;